// Traducción de la paleta hce-* (packages/hce-chart/src/styles.css) a valores
// que recharts puede consumir directamente (props, no clases Tailwind — SVG
// no las resuelve). Ver PLAN.md, "Diseño visual" de la Fase 1: sin rediseño,
// mismo look editorial/clínico que el resto de la app, no el aspecto
// "dashboard genérico" por defecto de una librería de charting.
export const TEMA_GRAFICO = {
  fondo: 'var(--color-hce-paper)',
  texto: 'var(--color-hce-ink)',
  textoMuted: 'var(--color-hce-muted)',
  rejilla: 'color-mix(in srgb, var(--color-hce-ink) 10%, transparent)',
  fontFamily: 'var(--font-sans)',
  fontFamilyMono: 'var(--font-mono)',
} as const;

/**
 * Orden fijo y determinístico por serie — no depende de qué dato llegó
 * primero. Cada color va acompañado de un estilo de trazo distinto
 * (ver Serie.trazo en tipos.ts): dos series nunca se distinguen solo por
 * color (riesgo de daltonismo, guía "Charts & Data" de la skill de diseño).
 */
export const PALETA_SERIES: ReadonlyArray<{ color: string; trazo: TrazoSerie }> = [
  { color: 'var(--color-hce-pine)', trazo: 'solido' },
  { color: 'var(--color-hce-clay)', trazo: 'discontinuo' },
  { color: 'var(--color-hce-sage)', trazo: 'punteado' },
  { color: 'var(--color-hce-pine-deep)', trazo: 'puntoraya' },
  { color: 'var(--color-hce-muted)', trazo: 'solido' },
  { color: 'var(--color-hce-clay)', trazo: 'punteado' },
  { color: 'var(--color-hce-sage)', trazo: 'discontinuo' },
] as const;

export type TrazoSerie = 'solido' | 'discontinuo' | 'punteado' | 'puntoraya';

export const STROKE_DASHARRAY: Record<TrazoSerie, string | undefined> = {
  solido: undefined,
  discontinuo: '6 3',
  punteado: '2 3',
  puntoraya: '8 3 2 3',
};
